var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "grid-view",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(170,170,170,0.5)"
      }
    },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c("div", { staticClass: "section operations" }, [
            _c("div", { staticClass: "triggers" }, [
              _c(
                "div",
                { staticStyle: { display: "inline-block" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100px" },
                      on: { change: _vm.onTimeRangeChange },
                      model: {
                        value: _vm.timeRange,
                        callback: function($$v) {
                          _vm.timeRange = $$v
                        },
                        expression: "timeRange"
                      }
                    },
                    _vm._l(_vm.TIME_RANGES, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  ),
                  _c("el-date-picker", {
                    staticStyle: { width: "120px", margin: "0 5px" },
                    attrs: {
                      disabled: _vm.timeRange !== _vm.CUSTOM.code,
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      editable: false,
                      clearable: false
                    },
                    model: {
                      value: _vm.filter.estimatedDateOfWarehousingeStart,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.filter,
                          "estimatedDateOfWarehousingeStart",
                          $$v
                        )
                      },
                      expression: "filter.estimatedDateOfWarehousingeStart"
                    }
                  }),
                  _vm._v("- "),
                  _c("el-date-picker", {
                    staticStyle: { width: "120px", "margin-left": "5px" },
                    attrs: {
                      disabled: _vm.timeRange !== _vm.CUSTOM.code,
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      editable: false,
                      clearable: false
                    },
                    model: {
                      value: _vm.filter.estimatedDateOfWarehousingeEnd,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.filter,
                          "estimatedDateOfWarehousingeEnd",
                          $$v
                        )
                      },
                      expression: "filter.estimatedDateOfWarehousingeEnd"
                    }
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "input-label",
                      staticStyle: { "margin-left": "20px" }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WarehouseNo")) + ":")]
                  ),
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    model: {
                      value: _vm.filter.warehouseNo,
                      callback: function($$v) {
                        _vm.$set(_vm.filter, "warehouseNo", $$v)
                      },
                      expression: "filter.warehouseNo"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.queryJobs()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { margin: "0 5px" },
                      on: { change: _vm.resetTimer },
                      model: {
                        value: _vm.autoRefresh,
                        callback: function($$v) {
                          _vm.autoRefresh = $$v
                        },
                        expression: "autoRefresh"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.AutomaticallyRefresh")))]
                  )
                ],
                1
              )
            ])
          ]),
          _c("cargo-ag-grid", {
            staticClass: "section grid-wrapper",
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }